export default __webpack_public_path__ + "static/media/ic-test.66f2ef46.svg";